import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { OperatorQueryKey } from '@/modules/operator/keys'
import {
	GetUploadFileUrlResponse,
	GetUploadlFileUrlRequest,
} from '@/modules/operator/type'
import { getBannerGameUploadFileUrl } from '../../services'

interface CreateFileUrlParams {
	payload: GetUploadlFileUrlRequest
}

export default function useMutationCreateBannerGameFileUrl(
	props?: UseBaseMutationOptions<GetUploadFileUrlResponse, CreateFileUrlParams>,
) {
	return useMutation({
		mutationKey: [OperatorQueryKey.GetUploadBannerGameFileUrl],
		mutationFn: (params) => getBannerGameUploadFileUrl(params.payload),
		...props,
	})
}
